const styles = theme => ({
  value: theme.mixins.gutters({
    margin: 0,
    fontWeight: 200
  }),
  graphHeader:{
    textAlign:'left',
    paddingLeft:75,
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/common/results/views/next/line/styles.js